export const Constants = {
    animationDuration: 300,
    webUrl: process.env.REACT_APP_WEB_URL ?? "",
};
